import { DafPrivilegeTypeItem } from '@generated'
import { FC, useState } from 'react'
import { Item, getKontentImage } from '@lib/kontent'
import { PrivilegeItem } from '@lib/kontent/models/PrivilegeItem'
import { CleanButton, Image, OldText } from '@gassan-ui'
import { PrivilegeSliderItemModal } from './Modal'

type PrivilegeSliderItemProps = Item<PrivilegeItem> & {
  modularContent: { [key: string]: any }
  dafItem: DafPrivilegeTypeItem
}

export const PrivilegeSliderItem: FC<PrivilegeSliderItemProps> = (props) => {
  const [showModal, setShowModal] = useState(false)
  return (
    <>
      <CleanButton
        className="group flex min-w-[60%] cursor-pointer snap-start flex-col pb-1 text-left sm:min-w-[40%] lg:min-w-[calc(25%-18px)]"
        onClick={() => setShowModal(true)}
      >
        <div className="mb-4 w-full shrink-0 transition-opacity group-hover:opacity-80">
          <Image
            className="aspect-[10/6]"
            sources={[
              getKontentImage(props.elements.image___placeholder_image.value[0].url, {
                width: 600,
              }),
            ]}
            alt={props.elements.image___placeholder_image.value[0].description as string}
            placeholderSrc={getKontentImage(props.elements.image___placeholder_image.value[0].url, {
              width: 50,
            })}
          />
        </div>
        <div>
          <OldText variant="regular" className="group-hover:underline">
            {props.elements.title.value}
          </OldText>
        </div>
      </CleanButton>
      <PrivilegeSliderItemModal
        open={showModal}
        handleRequestClose={() => setShowModal(false)}
        {...props}
      />
    </>
  )
}
